import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  paper: {
    boxSizing: 'border-box',
    width: 800,
    maxWidth: '92vw',
    borderRadius: 8,
    padding: 40,
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    width: '100%',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  titleIcon: {
    width: 28,
    height: 28,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    backgroundColor: C.iconBoxBg,
    '& svg': { fontSize: 16, color: C.strongText },
  },
  title: {
    fontSize: 22,
    fontWeight: 400,
    lineHeight: '28px',
    color: C.strongText,
  },
  divider: {
    alignSelf: 'stretch',
    width: 1,
    flexShrink: 0,
    borderRadius: 4,
    backgroundColor: C.divider,
  },
  noteLine: {
    display: 'block',
    marginTop: 4,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
  },
  help: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
    padding: 0,
    border: 'none',
    background: 'none',
    textDecoration: 'none',
    color: C.linkBlue,
    cursor: 'pointer',
    '& svg': { fontSize: 16 },
  },
  helpText: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.linkBlue,
    whiteSpace: 'nowrap',
  },
  close: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: 0,
    '& svg': { fontSize: 24, color: C.mutedText },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  bodyText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.mutedText,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 24,
    width: '100%',
  },
  button: {
    boxSizing: 'border-box',
    height: 40,
    padding: '10px 24px',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.strongText,
  },
  cancelButton: {
    backgroundColor: C.cardBg,
    border: `1px solid ${C.stepUpcomingBorder}`,
  },
  proceedButton: {
    // M3 primary orange (same token as the status banner accent).
    backgroundColor: C.bannerBorder,
    border: 'none',
  },
}))
